import { h, Component, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pk-divider',
  styleUrl: './scss/pk-divider.scss',
  shadow: true,
})
export class PkDivider {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** Direction (horizontal or vertical) **/
  @Prop() direction: 'horizontal' | 'vertical' = 'horizontal';

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    return <Host class={{ divider: true, 'divider--vertical': this.direction === 'vertical' }} />;
  }
}
